import axios from 'axios'
import store from '../store/store'

const serviceClient = axios.create({
  // baseURL: 'http://localhost:54930/v1',
  baseURL: 'https://api.easy-trac.de/v1',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

// sets authorization header if token exists
serviceClient.interceptors.request.use(function (config) {
  var benutzer = JSON.parse(localStorage.getItem("benutzer"))

  if (benutzer && benutzer.token) {
    config.headers.Authorization = `Bearer ${benutzer.token}`
  }

  return config
});


let isRefreshing = false;
let subscribers = [];

serviceClient.interceptors.response.use(
  (response) => {
    return response
  },
  err => {
    const { config, response: { status, data } } = err;
    const originalRequest = config;

    if (status === 401) {
      if (data == 'not allowed') return err
      if (data == 'invalid token') store.dispatch('abmelden')

      if (!isRefreshing) {
        isRefreshing = true;
        new Promise((resolve, reject) => {
          store.dispatch('refresh')
            .then(res => {
              resolve(res)
            })
            .catch(error => {
              reject(error)
            })
        })
          .then(res => {
            const { data } = res;
            isRefreshing = false;
            onRrefreshed(data.token);
            subscribers = [];
          })
          .catch(undefined)
      }
      const requestSubscribers = new Promise(resolve => {
        subscribeTokenRefresh(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          resolve(axios(originalRequest));
        });
      });
      return requestSubscribers;
    }
    return Promise.reject(err);
  });

function subscribeTokenRefresh(cb) {
  subscribers.push(cb);
}

function onRrefreshed(token) {
  subscribers.map(cb => cb(token));
}


export default {


  // Auth
  logout(id) {
    return serviceClient.get(`/auth/logout/${id}`)
  },
  register(user) {
    return serviceClient.post('/auth/register', JSON.stringify(user))
  },
  login(user) {
    return serviceClient.post('/auth/login', JSON.stringify(user))
  },
  refreshToken(refreshData) {
    return serviceClient.post('/auth/refresh', JSON.stringify(refreshData))
  },

  // Admin
  getAllUsers() {
    return serviceClient.get('/admin/benutzer')
  },
  adminGetUser(userId) {
    return serviceClient.get(`/admin/benutzer/${userId}`)
  },
  adminGetUserKontakte(userId) {
    return serviceClient.get(`/admin/benutzer/${userId}/kontakte`)
  },
  adminGetUserFotoalben(userId) {
    return serviceClient.get(`/admin/benutzer/${userId}/fotoalben`)
  },
  adminGetUserFotoalbumFotos(userId, fotoalbumId) {
    return serviceClient.get(`/admin/benutzer/${userId}/fotos/${fotoalbumId}`)
  },
  adminGetUserGeraete(userId) {
    return serviceClient.get(`/admin/benutzer/${userId}/geraete`)
  },
  adminGetDeviceMessagesCSV(deviceID) {
    return serviceClient.get(`/admin/geraet/sigfox/messages/csv/${deviceID}`)
  },
  adminDownloadDeviceMessagesCSV(fileName) {
    return serviceClient.get(`/admin/geraet/sigfox/messages/download/${fileName}`)
  },

  adminCreateUser(user) {
    return serviceClient.post(`/admin/benutzer/create`, user)
  },
  adminCreateUserKontakt(userId, kontakt) {
    return serviceClient.post(`/admin/benutzer/${userId}/kontakt/create`, kontakt)
  },
  adminCreateUserFotoalbum(userId, fotoalbumTitel) {
    return serviceClient.post(`/admin/benutzer/${userId}/fotoalbum/${fotoalbumTitel}/create`)
  },
  adminCreateUserGeraet(userId, geraet) {
    return serviceClient.post(`/admin/benutzer/${userId}/geraet/create`, geraet)
  },
  adminSetBenutzerSmsProvider(userId, smsProvider) {
    return serviceClient.post(`/admin/benutzer/${userId}/sms/provider`, smsProvider)
  },

  adminUpdateUser(user) {
    return serviceClient.put(`/admin/benutzer/update`, user)
  },
  adminUpdateUserPasswort(userId, passwort) {
    return serviceClient.put(`/admin/benutzer/${userId}/passwort/update`, passwort)
  },
  adminUpdateUserKontakt(userId, kontakt) {
    return serviceClient.put(`/admin/benutzer/${userId}/kontakt/update`, kontakt)
  },
  adminUpdateUserFotoalbum(userId, fotoalbum) {
    return serviceClient.put(`/admin/benutzer/${userId}/fotoalbum/update`, fotoalbum)
  },
  adminUpdateUserGeraet(userId, geraet) {
    return serviceClient.put(`/admin/benutzer/${userId}/geraet/update`, geraet)
  },
  updateFunctions(functions) {
    return serviceClient.put('/admin/benutzer/funktionen', functions)
  },

  adminDeleteUser(userId) {
    return serviceClient.delete(`/admin/benutzer/${userId}`)
  },
  adminDeleteUserKontakt (userId, kontaktId) {
    return serviceClient.delete(`/admin/benutzer/${userId}/kontakt/${kontaktId}/delete`)
  },
  adminDeleteUserFotoalbum (userId, fotoalbumId) {
    return serviceClient.delete(`/admin/benutzer/${userId}/fotoalbum/${fotoalbumId}/delete`)
  },
  adminDeleteUserGeraet (userId, geraetId) {
    return serviceClient.delete(`/admin/benutzer/${userId}/geraet/${geraetId}/delete`)
  },

  // Benutzer
  getBenutzer() {
    return serviceClient.get('/benutzer')
  },
  getUserImage() {
    return serviceClient.get('/benutzer/image')
  },
  getAllUserMessages() {
    return serviceClient.get('/benutzer/messages/all')
  },
  getNewUserMessages() {
    return serviceClient.get('/benutzer/messages/new')
  },
  getZuhauseStatus() {
    return serviceClient.get('/benutzer/zuhausestatus')
  },
  resetPasswort(email) {
    return serviceClient.get(`/benutzer/passwort/reset/${email}`)
  },
  uploadUserImage(image) {
    return serviceClient.post('/benutzer/image', image)
  },
  setZuhauseStatus(zuhause) {
    return serviceClient.post(`/benutzer/zuhausestatus/${Number(zuhause)}`)
  },
  setSmsProvider(smsProvider) {
    return serviceClient.post('/benutzer/sms/provider', smsProvider)
  },
  updateUser(user) {
    return serviceClient.put('/benutzer', user)
  },
  updatePasswort(changePasswortData) {
    return serviceClient.put('/benutzer/password', changePasswortData)
  },
  updateUserMessage(userMessage) {
    return serviceClient.put('/benutzer/message/update', userMessage)
  },
  deleteUser() {
    return serviceClient.delete('/benutzer')
  },
  deleteUserImage() {
    return serviceClient.delete('/benutzer/image')
  },
  deleteUserMessage(messageId) {
    return serviceClient.delete(`/benutzer/message/delete/${messageId}`)
  },

  // Email
  sendEmailToFavoriten(message) {
    return serviceClient.post('/email/favoriten', JSON.stringify(message))
  },
  sendEmailtoKontakt(kontaktId, message) {
    return serviceClient.post(`/email/${kontaktId}`, JSON.stringify(message))
  },

  // Fotoalbum
  getFotoalbum(id) {
    return serviceClient.get(`/fotoalbum/${id}`)
  },
  getFotoalben() {
    return serviceClient.get('/fotoalben')
  },
  getFotoalbumImage(fotoalbumId, fileName) {
    return serviceClient.get(`/fotoalbum/${fotoalbumId}/${fileName}`)
  },
  createFotoalbum(titel) {
    return serviceClient.post(`/fotoalbum/${titel}`)
  },
  uploadFotoalbumImage(fotoalbumId, file, filename) {
    return serviceClient.post(
      `/fotoalbum/${fotoalbumId}/image`,
      file,
      {
        onUploadProgress: (progressEvent) => {
          var progressBar = document.getElementById(filename)
          if (progressBar !== null) {
            progressBar.firstChild.style.width = Math.round((progressEvent.loaded * 100) / progressEvent.total) + '%'
          }
        },
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    )
  },
  deleteFotoalbum(fotoalbumID) {
    return serviceClient.delete(`/fotoalbum/${fotoalbumID}`)
  },

  // Geraete
  getAlleGeraete() {
    return serviceClient.get('/geraet')
  },
  getBenutzerGeraete() {
    return serviceClient.get('/geraet/benutzer')
  },
  createGeraet(geraet) {
    return serviceClient.post('/geraet', geraet)
  },
  updateGeraet(geraet) {
    return serviceClient.put('/geraet', geraet)
  },
  deleteGeraet(geraeteId) {
    return serviceClient.delete(`/geraet/${geraeteId}`)
  },

  // Geraetetypen
  getGeraetetypen() {
    return serviceClient.get('/geraetetyp')
  },
  createGeraetetyp(geraetetyp) {
    return serviceClient.post('/geraetetyp', geraetetyp)
  },
  deleteGeraetetyp(geraetetypId) {
    return serviceClient.delete(`/geraetetyp/${geraetetypId}`)
  },

  // Home
  checkConnection() {
    return serviceClient.get('/ping')
  },

  // Kontakte
  getUserContacts() {
    return serviceClient.get('/kontakt/benutzer')
  },
  createContact(contact) {
    return serviceClient.post('/kontakt', JSON.stringify(contact))
  },
  uploadContactImage(kontaktId, file) {
    return serviceClient.post(`/kontakt/${kontaktId}/image`, file, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  updateContact(kontakt) {
    return serviceClient.put('/kontakt', kontakt)
  },
  deleteContact(kontaktId) {
    return serviceClient.delete(`/kontakt/${kontaktId}`)
  },
  deleteContactImage(kontaktId) {
    return serviceClient.delete(`/kontakt/${kontaktId}/image`)
  },

  // Sigfox
  getSigfoxData(deviceId) {
    return serviceClient.get(`/sigfox/${deviceId}`)
  },
  getSigfoxDataById() {
    return serviceClient.get(`/sigfox/entry`)
  },
  getSigfoxLastDevicePosition(deviceId){
    return serviceClient.get(`/sigfox/lastPosition/${deviceId}`)
  },
  getAllSigfoxData() {
    return serviceClient.get('/sigfox')
  },
  postDecodeSigfoxMessage(message) {
    return serviceClient.post('/sigfox/decode', message)
  },

  // SMS
  sendHilfeSmsToFavoriten() {
    return serviceClient.get('/sms/hilfe/kontakte/favoriten')
  }


}